import React from 'react';
import { motion } from 'framer-motion';
type WelcomeProps = {
  onGetStarted: () => void;
};
export const Welcome: React.FC<WelcomeProps> = ({
  onGetStarted
}) => {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 1
  }} className="flex flex-col items-center justify-center min-h-[80vh] text-center px-4" data-id="element-1368">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.8
    }} className="mb-8" data-id="element-1369">
        <img src="https://images.unsplash.com/photo-1506318137071-a8e063b4bec0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80" alt="CareerAstro Logo" className="w-32 h-32 mx-auto rounded-full bg-[#7D56F4] p-2" data-id="element-1370" />
        <h1 className="text-4xl md:text-5xl font-bold mt-6 bg-gradient-to-r from-[#7D56F4] to-[#FF8F5E] text-transparent bg-clip-text" data-id="element-1371">
          CareerAstro
        </h1>
      </motion.div>
      <motion.h2 initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.6,
      duration: 0.8
    }} className="text-xl md:text-2xl mb-8 text-[#E1E6FF]" data-id="element-1372">
        Discover Your True Career Path in the Stars
      </motion.h2>
      <motion.div className="relative w-full max-w-md h-48 mb-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} data-id="element-1373">
        <div className="absolute inset-0" data-id="element-1374">
          {/* Constellation animation would go here in a real implementation */}
          <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-[#7D56F4] rounded-full" data-id="element-1375"></div>
          <div className="absolute top-1/2 left-1/3 w-3 h-3 bg-[#FF8F5E] rounded-full" data-id="element-1376"></div>
          <div className="absolute top-1/3 left-2/3 w-2 h-2 bg-[#7D56F4] rounded-full" data-id="element-1377"></div>
          <div className="absolute top-2/3 left-1/2 w-2 h-2 bg-[#19D3DA] rounded-full" data-id="element-1378"></div>
          <div className="absolute top-3/4 left-3/4 w-3 h-3 bg-[#FF8F5E] rounded-full" data-id="element-1379"></div>
          {/* Career icons */}
          <div className="absolute top-1/4 left-1/4 mt-4 ml-4" data-id="element-1380">
            <div className="bg-[#1C2541] p-2 rounded-lg opacity-80" data-id="element-1381">👩‍💻</div>
          </div>
          <div className="absolute top-1/2 left-1/3 mt-4 ml-4" data-id="element-1382">
            <div className="bg-[#1C2541] p-2 rounded-lg opacity-80" data-id="element-1383">🎨</div>
          </div>
          <div className="absolute top-1/3 left-2/3 mt-4 ml-4" data-id="element-1384">
            <div className="bg-[#1C2541] p-2 rounded-lg opacity-80" data-id="element-1385">👨‍⚕️</div>
          </div>
          <div className="absolute top-2/3 left-1/2 mt-4 ml-4" data-id="element-1386">
            <div className="bg-[#1C2541] p-2 rounded-lg opacity-80" data-id="element-1387">📊</div>
          </div>
        </div>
      </motion.div>
      <motion.button initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1.4,
      duration: 0.5
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={onGetStarted} className="bg-gradient-to-r from-[#7D56F4] to-[#19D3DA] text-white font-semibold py-3 px-8 rounded-full text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-1388">
        Begin Your Cosmic Journey
      </motion.button>
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.8,
      duration: 0.5
    }} className="mt-6 text-[#B8C0E0] text-sm" data-id="element-1389">
        Join over 10,000 star-guided professionals
      </motion.p>
    </motion.div>;
};